import { PageLayout } from '@/components/layout/PageLayout';

export function NotFound() {
  return (
    <PageLayout>
      <div className="text-center py-12 space-y-4">
        <h2 className="text-4xl font-bold text-muted-foreground">404</h2>
        <h3 className="text-xl font-semibold">Page Not Found</h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          The page you are looking for does not exist. Please check the URL or use the link provided in your email.
        </p>
      </div>
    </PageLayout>
  );
}
